import { Check } from 'lucide-react'
import { cn } from '@/lib/utils/cn'

export interface WizardStep {
  key: string
  label: string
}

export function WizardStepper({
  steps,
  current,
  onJump,
}: {
  steps: WizardStep[]
  current: number
  onJump?: (index: number) => void
}) {
  return (
    <div className="flex items-center gap-2">
      {steps.map((s, i) => {
        const done = i < current
        const active = i === current
        return (
          <div key={s.key} className="flex items-center gap-2">
            <button
              type="button"
              disabled={!onJump || i > current}
              onClick={() => onJump?.(i)}
              className={cn(
                'flex items-center gap-2 rounded-full ps-1.5 pe-3 py-1 transition-colors',
                active && 'bg-primary/10',
                (done || active) ? 'text-foreground' : 'text-muted-foreground',
                onJump && i <= current && 'hover:bg-muted/40 cursor-pointer',
              )}
            >
              <span
                className={cn(
                  'w-6 h-6 rounded-full flex items-center justify-center text-xs font-medium shrink-0',
                  done && 'bg-primary text-primary-foreground',
                  active && 'bg-primary text-primary-foreground',
                  !done && !active && 'bg-muted text-muted-foreground',
                )}
              >
                {done ? <Check className="w-3.5 h-3.5" /> : i + 1}
              </span>
              <span className="text-sm whitespace-nowrap">{s.label}</span>
            </button>
            {i < steps.length - 1 && <span className="w-6 h-px bg-border" />}
          </div>
        )
      })}
    </div>
  )
}
